import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import * as styles from './style.module.scss';
const {
    postImage,
    postImage__image
} = styles;

const PostImage = ({ content }) => {
  const img = getImage(content.image);

  return img ? (
    <section className={postImage}>
      <figure>
        <GatsbyImage
          className={postImage__image}
          image={img}
          alt={content.image.title}
        />
        <figcaption>{content.caption}</figcaption>
      </figure>
    </section>
  ) : null;
}

export default PostImage;

